module.exports = __webpack_public_path__ + "img/file.1d9ed5f.png";